import { useTranslation } from "react-i18next";
import { Profile2User, I3Dcube, Sms, Call, Calendar, Location } from "iconsax-react";
import { formatDateForDisplay } from "@/shared/utils";
import type { SelfServiceProfile, VolunteerProfile } from "../../shared/types";
import ProfileDataRow from "./ProfileDataRow";

interface PersonalInfoSectionProps {
  profile: SelfServiceProfile;
}

export default function PersonalInfoSection({ profile }: PersonalInfoSectionProps) {
  const { t, i18n } = useTranslation("EmployeePortal");

  if (profile.user_type === "volunteer") {
    const volunteer = profile as VolunteerProfile;
    const locale = i18n.language;
    const regionName = volunteer.region
      ? (locale === "kk" ? volunteer.region.name_kk : volunteer.region.name_ru)
      : null;

    return (
      <div className="flex flex-col">
        <h2 className="text-display-2xs content-base-primary mb-7">{t("overview.personalInfo.panelTitle")}</h2>
        <div className="flex flex-col">
          <ProfileDataRow icon={Profile2User} label={t("overview.personalInfo.fullName")} value={volunteer.full_name || ""} />
          <ProfileDataRow icon={Calendar} label={t("overview.personalInfo.dateOfBirth")} value={formatDateForDisplay(volunteer.date_of_birth)} />
          <ProfileDataRow icon={Location} label={t("overview.personalInfo.region")} value={regionName} />
          <ProfileDataRow icon={Sms} label={t("overview.personalInfo.email")} value={volunteer.email || ""} />
          <ProfileDataRow icon={Call} label={t("overview.personalInfo.phone")} value={volunteer.phone || ""} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <h2 className="text-display-2xs content-base-primary mb-7">{t("overview.personalInfo.panelTitle")}</h2>
      <div className="flex flex-col">
        <ProfileDataRow icon={Profile2User} label={t("overview.personalInfo.fullName")} value={profile?.full_name || ""} />
        {"iin" in profile && (
          <ProfileDataRow icon={I3Dcube} label={t("overview.personalInfo.iin")} value={profile.iin || ""} />
        )}
        <ProfileDataRow icon={Sms} label={t("overview.personalInfo.email")} value={profile?.email || ""} />
        <ProfileDataRow icon={Call} label={t("overview.personalInfo.phone")} value={profile?.phone || ""} />
      </div>
    </div>
  );
}

